import React from 'react';

/**
 * Lightweight Box component to replace MUI Box
 * Converts sx prop to inline styles for compatibility
 */
export default function Box({ 
  children, 
  sx = {}, 
  component = 'div',
  className = '',
  style = {},
  ...props 
}) {
  // Convert sx object to inline styles
  // Keep camelCase as React inline styles expect camelCase
  const sxStyles = {};
  
  if (sx) {
    Object.keys(sx).forEach(key => {
      // Handle nested selectors (ignore them - they're for MUI)
      if (key.startsWith('&') || key.includes(':')) {
        return; // Skip pseudo-selectors and nested styles
      }
      
      // Keep the key as-is (React uses camelCase for inline styles)
      sxStyles[key] = sx[key];
    });
  }

  const Component = component;
  const mergedStyle = { ...sxStyles, ...style };

  return (
    <Component 
      className={className}
      style={mergedStyle}
      {...props}
    >
      {children}
    </Component>
  );
}
